<template>
  <div class="final-projects-other-projects mt-4 px-3 py-2">
    Other final projects
  </div>
</template>

<style>
.final-projects-other-projects {
  text-transform: uppercase;
  font-weight: 600;
}
</style>
